<script setup="">
import { computed } from "vue";

import SimpleInput from "@/Components/Form/SimpleInput.vue";
import SimpleDescription from "@/Components/SimpleDescription.vue";

import { useTeamSubscription } from "@/composables/useTeamSubscription";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  update: {
    type: Function,
    required: true
  }
});

const { isOnFreePlan } = useTeamSubscription();

const ga4 = computed({
  get: () => props.campaign.settings?.script?.ga4,
  set: (value) => props.update("settings.script.ga4", value)
});

const meta = computed({
  get: () => props.campaign.settings?.script?.meta,
  set: (value) => props.update("settings.script.meta", value)
});

const kakao = computed({
  get: () => props.campaign.settings?.script?.kakao,
  set: (value) => props.update("settings.script.kakao", value)
});

const naver = computed({
  get: () => props.campaign.settings?.script?.naver,
  set: (value) => props.update("settings.script.naver", value)
});

const daangn = computed({
  get: () => props.campaign.settings?.script?.daangn,
  set: (value) => props.update("settings.script.daangn", value)
});

const tiktok = computed({
  get: () => props.campaign.settings?.script?.tiktok,
  set: (value) => props.update("settings.script.tiktok", value)
});
</script>

<template>
  <div class="space-y-4">
    <SimpleDescription v-if="isOnFreePlan" class="rounded-lg bg-gray-100 p-2.5 font-bold dark:bg-zinc-800">
      마케팅 설정은 유료 플랜 이용자만 설정할 수 있습니다.
    </SimpleDescription>

    <div>
      <SimpleInput v-model="ga4" label="구글 애널리틱스4" label-class="text-600 text-sm " :disabled="isOnFreePlan" :required="false" />
      <div class="text-right">
        <a class="mt-2 inline-block text-xs+ underline text-600" href="https://bit.ly/4g8ivMY" target="_blank"> 구글 ID 찾기 </a>
      </div>
    </div>
    <div>
      <SimpleInput v-model="meta" label="메타 픽셀" label-class="text-600 text-sm " :disabled="isOnFreePlan" :required="false" />
      <div class="text-right">
        <a class="mt-2 inline-block text-xs+ underline text-600" href="https://bit.ly/4g8ivMY" target="_blank"> 메타 픽셀 ID 찾기 </a>
      </div>
    </div>
    <div>
      <SimpleInput v-model="kakao" label="카카오 픽셀" label-class="text-600 text-sm " :disabled="isOnFreePlan" :required="false" />
      <div class="text-right">
        <a class="mt-2 inline-block text-xs+ underline text-600" href="https://bit.ly/4g8ivMY" target="_blank"> 카카오 픽셀 ID 찾기 </a>
      </div>
    </div>
    <div>
      <SimpleInput v-model="naver" label="네이버 스크립트" label-class="text-600 text-sm " :disabled="isOnFreePlan" :required="false" />
      <div class="text-right">
        <a class="mt-2 inline-block text-xs+ underline text-600" href="https://bit.ly/4g8ivMY" target="_blank"> 네이버 스크립트 ID 찾기 </a>
      </div>
    </div>
    <div>
      <SimpleInput v-model="daangn" label="당근 스크립트" label-class="text-600 text-sm " :disabled="isOnFreePlan" :required="false" />
      <div class="text-right">
        <a class="mt-2 inline-block text-xs+ underline text-600" href="https://bit.ly/4g8ivMY" target="_blank"> 당근 스크립트 ID 찾기 </a>
      </div>
    </div>
    <div>
      <SimpleInput v-model="tiktok" label="틱톡 스크립트" label-class="text-600 text-sm " :disabled="isOnFreePlan" :required="false" />
      <div class="text-right">
        <a class="mt-2 inline-block text-xs+ underline text-600" href="https://bit.ly/4g8ivMY" target="_blank"> 틱톡 스크립트 ID 찾기 </a>
      </div>
    </div>
  </div>
</template>
